import { css } from '@emotion/css';
import sportPlayers from 'assets/images/figma-home/sport-players.png';
import sportStadium from 'assets/images/figma-home/sport-stadium.png';
import { colors } from 'constants/theme';

const homePageStyles = {
    homeContainer: css`
        min-height: 100%;
        overflow: hidden;
        background: ${colors.bgDark};
        color: ${colors.white};
    `,
    sectionContainer: css`
        width: min(1360px, calc(100% - 48px));
        margin: 0 auto;
        @media (max-width: 740px) { width: min(100% - 28px, 1360px); }
    `,
    bannerSlide: css`
        height: 370px;
        background: #071d31;
        .swiper, .swiper-wrapper, .swiper-slide { height: 100%; }
        .swiper-slide { display: flex; align-items: stretch; justify-content: center; }
        @media (max-width: 740px) { height: 190px; }
    `,
    imgBanner: css`
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    `,
    paginationCustom: css`
        position: absolute;
        z-index: 3;
        left: 50%;
        bottom: 15px;
        display: flex;
        gap: 8px;
        transform: translateX(-50%);
    `,
    pagination: css`width: 12px; height: 12px; border-radius: 50%; background: rgba(0,0,0,.62); transition: width 180ms ease, background 180ms ease;`,
    paginationFocus: css`width: 26px; border-radius: 10px; background: ${colors.secondary};`,
    casinoSection: css`padding: 50px 0; background: ${colors.bgDark};`,
    sectionTitle: css`
        display: inline-flex;
        align-items: center;
        gap: 10px;
        margin: 0 0 20px;
        color: ${colors.white};
        font-size: 20px;
        line-height: 36px;
        font-style: italic;
        font-weight: 900;
        letter-spacing: .02em;
        text-transform: uppercase;
        span { display: grid; place-items: center; width: 36px; height: 36px; border-radius: 50%; color: #172743; background: radial-gradient(circle at 30% 30%, #fff5b6, #d79b26); font-style: normal; }
    `,
    vendorGrid: css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 18px;
        padding-top: 20px;
        @media (max-width: 960px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 520px) { grid-template-columns: 1fr; }
    `,
    vendorCard: css`
        position: relative;
        min-height: 216px;
        overflow: hidden;
        border: 1px solid rgba(124, 148, 234, .42);
        border-radius: 10px;
        background-color: #0d1d39;
        background-position: center;
        background-size: auto 106%;
        background-repeat: no-repeat;
        color: ${colors.white};
        text-align: left;
        cursor: pointer;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, .08), 0 10px 20px rgba(0, 0, 0, .16);
        transition: transform 220ms ease, box-shadow 220ms ease, filter 220ms ease, border-color 220ms ease;
        &::before { content: ''; position: absolute; inset: 0; background: linear-gradient(118deg, rgba(9, 23, 49, .97) 0%, rgba(15, 37, 72, .85) 43%, rgba(10, 24, 48, .06) 74%); pointer-events: none; }
        &::after { content: ''; position: absolute; right: -35px; bottom: -92px; width: 180px; height: 180px; border: 1px solid rgba(255, 217, 138, .26); border-radius: 50%; box-shadow: 0 0 0 25px rgba(255, 217, 138, .05), 0 0 0 50px rgba(255, 217, 138, .04); pointer-events: none; }
        &[data-tone='1']::before { background: linear-gradient(118deg, rgba(15, 33, 68, .97) 0%, rgba(47, 31, 84, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        &[data-tone='2']::before { background: linear-gradient(118deg, rgba(10, 39, 59, .97) 0%, rgba(25, 76, 88, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        &[data-tone='3']::before { background: linear-gradient(118deg, rgba(56, 29, 35, .97) 0%, rgba(96, 47, 47, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        &[data-tone='4']::before { background: linear-gradient(118deg, rgba(40, 34, 72, .97) 0%, rgba(49, 57, 112, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        &[data-tone='5']::before { background: linear-gradient(118deg, rgba(59, 38, 18, .97) 0%, rgba(118, 72, 27, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        &[data-tone='6']::before { background: linear-gradient(118deg, rgba(23, 50, 67, .97) 0%, rgba(25, 91, 115, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        &[data-tone='7']::before { background: linear-gradient(118deg, rgba(70, 31, 35, .97) 0%, rgba(122, 54, 66, .84) 43%, rgba(10, 24, 48, .06) 74%); }
        .vendor-label { position: absolute; z-index: 1; left: 18px; top: 20px; max-width: 54%; color: #fff5d5; font-size: 14px; font-weight: 900; line-height: 1.25; text-transform: uppercase; text-shadow: 0 2px 7px #000; }
        .play { position: absolute; z-index: 1; left: 18px; bottom: 18px; padding: 8px 13px; border: 1px solid rgba(255, 217, 138, .8); border-radius: 99px; background: rgba(3, 15, 29, .56); color: #fff3bf; font-size: 10px; font-weight: 900; letter-spacing: .03em; transition: background 180ms ease, color 180ms ease; }
        &:hover { transform: translateY(-6px); border-color: rgba(255, 217, 138, .9); filter: saturate(1.12) brightness(1.07); box-shadow: 0 17px 30px rgba(0,0,0,.34), 0 0 20px rgba(255, 173, 51, .12); .play { background: ${colors.secondary}; color: ${colors.blackText}; } }
    `,
    sportSection: css`
        position: relative;
        padding: 29px 0 38px;
        background: linear-gradient(0deg, rgba(4,24,23,.94), rgba(4,24,23,.18)), url(${sportStadium}) center / cover;
    `,
    sportLayout: css`
        display: grid;
        grid-template-columns: 650px minmax(0, 1fr);
        gap: 21px;
        align-items: center;
        @media (max-width: 1100px) { grid-template-columns: 1fr; }
    `,
    sportLayoutCompact: css`
        width: 100%;
    `,
    matchFeature: css`
        min-height: 430px;
        position: relative;
        overflow: hidden;
        border-radius: 8px;
        background: linear-gradient(90deg, rgba(0,19,38,.86), rgba(0,19,38,.1)), url(${sportStadium}) center / cover;
        &::after { content: ''; position: absolute; inset: -70px -55px -180px 23%; background: url(${sportPlayers}) right top / auto 128% no-repeat; pointer-events: none; }
        .match-copy { position: absolute; z-index: 1; left: 36px; bottom: 56px; width: min(310px, calc(100% - 60px)); text-align: center; }
        .hot-label { display: inline-block; padding: 7px 18px; border-radius: 4px; background: #ff1a0b; font-size: 13px; font-weight: 800; }
        .teams { display: grid; grid-template-columns: 1fr 40px 1fr; align-items: center; gap: 12px; margin: 16px 0 8px; font-size: 16px; }
        .teams b { font-size: 28px; color: ${colors.secondary}; }
        p { margin: 0 0 16px; font-size: 13px; color: #d8f9f6; }
        button { min-width: 180px; padding: 12px 24px; border-radius: 4px; background: ${colors.white}; color: #d81e13; font-weight: 900; transition: transform 180ms ease, background 180ms ease; }
        button:hover { transform: translateY(-3px); background: ${colors.secondary}; color: ${colors.blackText}; }
    `,
    sportVendorGrid: css`
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 18px;
        & > button { min-height: 190px; }
        @media (max-width: 840px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
        @media (max-width: 520px) { grid-template-columns: 1fr; }
    `,
    sportVendorCard: css`
        min-height: 190px;
        background-size: auto 104%;
        &::before { background: linear-gradient(118deg, rgba(6, 33, 54, .97) 0%, rgba(11, 82, 106, .83) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='1']::before { background: linear-gradient(118deg, rgba(30, 29, 78, .97) 0%, rgba(61, 49, 132, .84) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='2']::before { background: linear-gradient(118deg, rgba(57, 25, 38, .97) 0%, rgba(122, 44, 62, .84) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='3']::before { background: linear-gradient(118deg, rgba(17, 52, 39, .97) 0%, rgba(33, 103, 68, .84) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='4']::before { background: linear-gradient(118deg, rgba(63, 42, 18, .97) 0%, rgba(128, 78, 22, .84) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='5']::before { background: linear-gradient(118deg, rgba(49, 25, 68, .97) 0%, rgba(93, 45, 128, .84) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='6']::before { background: linear-gradient(118deg, rgba(21, 45, 72, .97) 0%, rgba(32, 91, 128, .84) 43%, rgba(7, 27, 51, .07) 74%); }
        &[data-tone='7']::before { background: linear-gradient(118deg, rgba(66, 27, 27, .97) 0%, rgba(128, 51, 42, .84) 43%, rgba(7, 27, 51, .07) 74%); }
    `,
    lotterySection: css`padding: 40px 0 76px; background: ${colors.bgDark};`,
    lotteryBlock: css`margin-bottom: 40px; &:last-child { margin-bottom: 0; }`,
    lotteryHeading: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        button { padding: 8px 13px; border: 1px solid ${colors.secondary}; border-radius: 4px; color: ${colors.secondary}; font-size: 11px; font-weight: 700; transition: background 180ms ease, color 180ms ease; }
        button span { margin-left: 6px; font-size: 15px; }
        button:hover { background: ${colors.secondary}; color: ${colors.blackText}; }
        h2 { margin-bottom: 12px; }
    `,
};

export default homePageStyles;
